import React, { useEffect, useState } from 'react';
import * as AppConsts from '@/utilities/AppConsts';
import * as AppUtils from '@/utilities/AppUtils';
import * as AppUtilities from '@/utilities/AppUtilities';
import Head from 'expo-router/head';
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';

interface MetaProps {
  title?: string,
  description?: string,
};

export function Meta({ title = "", description = AppConsts.TAGLINE }: MetaProps) : React.ReactNode {
  const community = useSelector((state: RootState) => state.user.current_community);

  const [finalTitle, setFinalTitle] = useState("Rabbl");

  useEffect(() => {
    let result = title == null ? "" : title;
    if (result.length > 0) {
      result += " - ";
    }
    if (AppUtils.isValidCommunity(community) && !AppUtils.isBlank(community?.name)) {
      result += community?.name + " Rabbl";
    } else {
      result += "Rabbl";
    }
    setFinalTitle(result);

    AppUtilities.info("Meta: Load: " + result, true);

  }, [title, community]);

  return (
    <Head>
      <title>{finalTitle}</title>
      <meta name="description" content={description} />
    </Head>
  );
};
